import React, { useState } from "react";
import TooltipArrow from "../images/TooltipArrow";
import { color } from "d3";

const CustomTooltip = ({ children }) => {
  const [visible, setVisible] = useState(false);
  const categories = [
    {
      name: "Low Risk",
      description:
        "Users with minimal or no suspicious activities. These users typically have standard transaction patterns and are unlikely to be involved in money laundering activities.",
      color: "28a745",
    },

    {
      name: "Medium Risk",
      description:
        "Users who exhibit some suspicious activities or unusual transaction patterns that warrant closer monitoring. These users may have some characteristics that could potentially indicate money laundering but do not pose an immediate high risk.",
      color: "d4af37",
    },
    {
      name: "High Risk",
      description:
        "Users with significant suspicious activities or clear indicators of money laundering. These users require immediate attention and thorough investigation due to their high likelihood of being involved in money laundering activities",
      color: "e65100",
    },
    {
      name: "Blocked",
      description:
        "The individual or entity is identified as being involved in illegal activities or is subject to sanctions. All transactions with them are prohibited, and they are barred from using the financial services.",
      color: "c82333",
    },
  ];

  return (
    <div className="relative">
      <div
        className=" flex "
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
      >
        {children}
      </div>
      {
        <div
          className={` ${
            visible ? "visible" : "invisible"
          } absolute w-[420px] h-[380px] bg-[#262626] rounded-2xl  flex flex-col items-start top-6 -left-[13px]`}
        >
          <div className=" relative p-4">
            <div className=" absolute -top-[5px]">
              <TooltipArrow />
            </div>
            {/* <div className=" text-xs font-medium text-white">
              <p className=" font-semibold flex items-center">
                <div
                  className={` mr-2 w-2 h-2 rounded-[2px] bg-[#28a745]`}
                ></div>{" "}
                <span> Low Risk: </span>
              </p>
              <p className="mt-1 pl-4 text-left">
                Users with minimal or no suspicious activities. These users
                typically have standard transaction patterns and are unlikely to
                be involved in money laundering activities.
              </p>
            </div> */}
            {categories.map((category, index) => (
              <div
                className={` text-xs font-medium text-white  ${
                  index !== 0 && "mt-[10px]"
                } `}
              >
                <p className=" font-semibold flex items-center">
                  <div
                    className={` mr-2 w-2 h-2 rounded-[2px] bg-[#${category.color}] `}
                  ></div>{" "}
                  <span> {category.name}: </span>
                </p>
                <p className="mt-1 pl-4 text-left">{category.description}</p>
              </div>
            ))}
          </div>
        </div>
      }
    </div>
  );
};

export default CustomTooltip;
